<div class="compare-panel">
    <div class="compare-title">Last Year Comparison</div>
    <div class="compare-sub">Compact year-over-year performance</div>

    @if (loading()) {
        <div class="compare-loading">
            <span class="material-icons-outlined spin">refresh</span>
        </div>
    } @else {
        <div class="compare-list">
            <article class="compare-item">
                <div class="compare-item-top">
                    <span class="compare-item-icon tone-blue">
                        <span class="material-icons-outlined">confirmation_number</span>
                    </span>
                    <div>
                        <small>Last Year Reservations</small>
                        <strong>{{ lastYearReservations() }}</strong>
                    </div>
                    @if (comparisonReservation()?.status) {
                        <span class="compare-rise" [class.up]="comparisonReservation()?.status === 'UP'" [class.down]="comparisonReservation()?.status === 'DOWN'">
                            {{ comparisonReservation()?.status === 'UP' ? '↑' : '↓' }} {{ comparisonReservation()?.value ?? 0 }}%
                        </span>
                    }
                </div>
                <div class="compare-track">
                    <div class="compare-fill" [style.width.%]="reservationBarWidth()"></div>
                </div>
                <div class="compare-foot">
                    <span>{{ lastYearReservations() }} last year</span>
                    <span>{{ totalReservations() }} current</span>
                </div>
            </article>

            <article class="compare-item">
                <div class="compare-item-top">
                    <span class="compare-item-icon tone-purple">
                        <span class="material-icons-outlined">person</span>
                    </span>
                    <div>
                        <small>Last Year Total Seat</small>
                        <strong>{{ lastYearSeats() }}</strong>
                    </div>
                    @if (comparisonSeat()?.status) {
                        <span class="compare-rise" [class.up]="comparisonSeat()?.status === 'UP'" [class.down]="comparisonSeat()?.status === 'DOWN'">
                            {{ comparisonSeat()?.status === 'UP' ? '↑' : '↓' }} {{ comparisonSeat()?.value ?? 0 }}%
                        </span>
                    }
                </div>
                <div class="compare-track">
                    <div class="compare-fill" [style.width.%]="seatBarWidth()" [style.background]="'linear-gradient(90deg, #6f55d9, #a177ee)'"></div>
                </div>
                <div class="compare-foot">
                    <span>{{ lastYearSeats() }} last year</span>
                    <span>{{ totalSeat() }} current</span>
                </div>
            </article>
        </div>
    }
</div>
